// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from "prop-types";
// import Scrollchor from 'react-scrollchor';

import { connect } from 'react-redux';
import Autocomplete  from 'react-google-autocomplete';
import SVGInline from "react-svg-inline"

import * as actions from '../../Actions/main';
import { AnalyticsService } from "../../Services";
import { ToggleMap } from "../Elements/Toggles";

// INNER IMPORTS
import Datepicker from './Datepicker';
import { isMobile } from '../../utils';

// import Dropdown from './Dropdown';
import {LIVE_MUSIC, BAND, SERVICE, MUSICIAN} from '../../consts';

// svgs
import searchBlueSVG from '../inlineSVGs/searchBlueSVG';

// styles
import './SearchBarHeader.css';

class SearchBarHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            placeSelected: {},
            searchStr: ''
        };

        this.autoCompleteRef = {};
    }

    componentDidMount() {
        document.addEventListener('keydown', this.keyDownHandler.bind(this));
    }

    componentDidUpdate(prevProps) {
        if (!prevProps || !prevProps.filters || !this.props.filters) return;

        // clean up inputs on type changes
        if (prevProps.filters.type !== this.props.filters.type || prevProps.filters.category !== this.props.filters.category) {
            this.setState({ searchStr: '', placeSelected: {} });
        }

        if (!!prevProps.filters.location && !this.props.filters.location) {
            if (this.autoCompleteRef.value) this.autoCompleteRef.value = ''
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyDownHandler.bind(this));
    }

    keyDownHandler(event) {
        if (!this.props.isSearchByNameMode || event.key !== 'Enter') return;
        event.preventDefault();
        this.handleOnSearchClick()
    }

    postSearch() {
        if (this.state.searchStr !== this.props.filters.title) this.props.clearPinsList()

        setTimeout(() => {
            if (!isMobile()) {
                setTimeout(() => {
                    window.scrollTo({
                        top: 550,
                        left: 0,
                        behavior: 'smooth'
                    })
                }, 500)
            }
        }, 500)
    }

    // If user changed dates - we should add the dates filters accordingly and reload the pins
    handleChangeDates(startDate, endDate, chosenDateLabel) {

        this.props.addFilter('begins', startDate)
        this.props.addFilter('ends', endDate)
        this.props.setChosenDateLabel(chosenDateLabel)
    }

    // If user chose a location, the map should focus on that location
    handleChangePlace(place) {
        if (!place || !place.geometry || !place.geometry.location || !place.geometry.viewport) return;

        const borderNorthEast = place.geometry.viewport.getNorthEast();
        const borderSouthWest = place.geometry.viewport.getSouthWest();

        this.props.changeLocationOnMap(place.geometry.location.lat(), place.geometry.location.lng());

        if (!borderNorthEast || !borderSouthWest) return;

        const locationObj = {}
        if (place.address_components) {
            place.address_components.forEach(addr => {
                locationObj[addr.types[0]] = addr.long_name
            })
        }

        const area = {
            left: borderSouthWest.lng(), // place.geometry.viewport.Ra.g, // west border
            right: borderNorthEast.lng(), // place.geometry.viewport.Ra.h, // east border,
            bottom: borderSouthWest.lat(), // place.geometry.viewport.Ab.g, // south border,
            top: borderNorthEast.lat(), //  place.geometry.viewport.Ab.h // north border,
            ...locationObj
        };

        this.props.addFilter('location', area);
        this.setState({ placeSelected: place }, () => {
            this.postSearch();
        });
    }

    handleChangeSearchValue() {
        this.props.addFilter('title', this.state.searchStr);

        this.setState({ placeSelected: {} }, () => {
            this.postSearch();
        });
    }

    handleOnSearchClick() {
        if (this.props.isSearchByNameMode && (this.props.filters.type === LIVE_MUSIC || this.props.filters.type === SERVICE)) {
           return this.handleChangeSearchValue();
        }

        this.props.changeLocationOnMap(0, 0);

        // TODO: horrible solution but cuts clients dev time and about to change anyway once map/ mocsaic logic request will change
        setTimeout(() => {
            this.handleChangePlace(this.state.placeSelected);
        }, 500)
    }

    // If the user changes the type (Services/Live music), the filters should change accordingly and reload the pins
    // We should remove previous category and subCategory as well
    changeType(value) {

        AnalyticsService.sendEvent(AnalyticsService.events.SEARCH_CAT_CHANGE, value, null, { value });
        window.location = `/#${value}`;

        this.props.resetFiltersType(value)
    }

    // this is to prevent search on each char typing
    handleLocationChange(value) {
        if (!value) {
            this.props.clearPinsList()
            this.props.addFilter('location', null);
            this.setState({ placeSelected: {} });
        }
    }

    handleToggleSearchMode(selectedType) {
        this.setState({ searchStr: '', placeSelected: {} });
        if (this.props.filters.type === BAND || this.props.filters.type === MUSICIAN) {
            return this.changeType(selectedType)
        }

        this.props.toggleSearchLocationMode();
    }

    getSearchPlaceholder() {
        const { type } = this.props.filters;

        switch (type) {
            case LIVE_MUSIC:
                return 'חפש הופעות לפי' // 'Search live shows by'
            case SERVICE:
                return 'חפש שירותי מוזיקה לפי' // 'Search music services by'
            default :
                return 'חפש לפי מיקום' // 'Search by location'
        }
    }

    renderTypeSelection() {
        if (!this.props.datatypes.types) return null;

        return this.props.datatypes.types.map((type, index) => {
            if (type.name === LIVE_MUSIC || type.name === SERVICE) return null;

            const isSelected = (this.props.filters || {}).type === type.name;

            let customLabel = 'FIND YOUR BAND';

            if (type.name === MUSICIAN) customLabel = 'FIND BAND MEMBER';

            return (
                <div
                    key={`map-top-bar-web-${type.name}-${index}`}
                    className={`what-side-item ${type.name} ${isSelected ? 'selected' : ''}`}
                    onClick={() => this.changeType(type.name)}
                >
                    {customLabel} fuc
                </div>
            )
        })

        /*
            <Dropdown
                options={this.props.datatypes.types.map((type)=>{return {name: type.name, text: type.plural}})}
                selected={this.props.filters.type}
                onChange={this.changeType.bind(this)}
            />
      */
    }

    renderSegmentHeader(text, addedClass = '') {
        return (
            <h3 className={`segment-header ${addedClass}`}>
                {text}
            </h3>
        )
    }

    // TODO: old search bar - TBR
    renderBandFinderLabels(type) {
        if (type !== BAND && type !== MUSICIAN) return null;

        return (
            <div className={`left-side-wrapper ${type}`}>
                <div className={`rounded-border ${type === BAND ? 'selected': ''}`}></div>
                {this.renderTypeSelection()}
            </div>
        )
    }

    renderWebToggleMap() {
        return <ToggleMap isMapTop={this.props.isMapTop} onToggle={() => this.props.toggleMapTop()} />
    }

    renderInput() {
        if (
            this.props.isSearchByNameMode &&
            (this.props.filters.type === LIVE_MUSIC || this.props.filters.type === SERVICE))
        {
            return (
                <div>
                    <input
                        className="search-input pac-target-input"
                        placeholder={this.getSearchPlaceholder()}
                        autoComplete="off"
                        defaultValue=""
                        value={this.state.searchStr || ''}
                        onChange={e => this.setState({ searchStr: e.target.value })}
                    />
                </div>
            )
        }

        return (
            <Autocomplete
                className="search-input"
                ref={(autoRef) => this.autoCompleteRef = autoRef && autoRef.refs && autoRef.refs.input}
                placeholder={this.getSearchPlaceholder()}
                onChange={(e) => this.handleLocationChange(e.target.value)}
                onPlaceSelected={(place) => { this.handleChangePlace(place) }}
                types={['geocode', 'establishment']}
            />
        )
    }

    renderSearchTypeBtns() {
        // if (this.props.filters.type !== LIVE_MUSIC && this.props.filters.type !== SERVICE) return null;

        const { type } = this.props.filters;

        let btnLeftStr = 'חבר להקה' // 'Band Member';
        if (type === LIVE_MUSIC) btnLeftStr = 'אמן' // 'Artist';
        if (type === SERVICE) btnLeftStr = 'שירות'// 'Service';

        return (
            <div className="search-type-btns-wrapper rtl">
                <button
                    className={`search-mode-btn ${this.props.filters.type} ${this.props.isSearchByNameMode ? 'selected' : ''} ${this.props.filters.type === MUSICIAN ? 'band-selected' : ''}`}
                    onClick={() => this.handleToggleSearchMode(MUSICIAN)}
                >{btnLeftStr}</button>
                <button
                    className={`search-mode-btn ${this.props.filters.type} ${!this.props.isSearchByNameMode ? 'selected' : ''} ${this.props.filters.type === BAND ? 'band-selected' : ''}`}
                    onClick={() => this.handleToggleSearchMode(BAND)}
                >{type === LIVE_MUSIC || type === SERVICE ? 'מיקום' : 'להקה'}</button>
            </div>
        )
    }

    render() {
        if (!this.props.datatypes) return null;

        return (
            <div className={`search-bar-header rtl ${this.props.filters.type}`}>
                <div id="web-search-bar"></div>
                {/*{!isMobile() ? this.renderBandFinderLabels(this.props.filters.type) : null}*/}
                <div className="right-side-wrapper">
                    <div className="where-wrapper">
                        {this.renderInput()}
                        {this.renderSearchTypeBtns()}
                    </div>

                    {this.props.filters.type === LIVE_MUSIC && !isMobile() ?
                        <div className="when-wrapper">
                            <Datepicker
                                isCaret
                                datatypes={this.props.datatypes}
                                onDatesChange={this.handleChangeDates.bind(this)}
                            />
                        </div>
                        : null
                    }
                </div>
                <div className={`end-wrapper ${this.props.filters.type}`} onClick={() => this.handleOnSearchClick()}>
                    <SVGInline className="search-icon" svg={searchBlueSVG} component="i"/>
                </div>
                {!isMobile() ? this.renderWebToggleMap() : null}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    datatypes: state.main.datatypes,
    isMapTop: state.main.isMapTop,
    isSearchByNameMode: state.main.isSearchByNameMode
});

SearchBarHeader.propTypes = {
    datatypes: PropTypes.object,
    filters: PropTypes.object,
    addFilter: PropTypes.func,
    updateFilters: PropTypes.func,
    resetFiltersType: PropTypes.func,
    getPinsCall: PropTypes.func,
    removeFilter: PropTypes.func,
    changeLocationOnMap: PropTypes.func,
    isMapTop: PropTypes.bool,
    isSearchByNameMode: PropTypes.bool,
    toggleMapTop: PropTypes.func,
    setChosenDateLabel: PropTypes.func,
    searchStr: PropTypes.string,
    toggleSearchLocationMode: PropTypes.func,
    clearPinsList: PropTypes.func,
    isHidden: PropTypes.bool
};

// connecting the component to the actions in order to be able to dispatch them from the component
export default connect(mapStateToProps, actions)(SearchBarHeader);




// WEBPACK FOOTER //
// ./src/Components/Main/SearchBarHeader.js